import { render } from "./slideVideo.vue?vue&type=template&id=bf1816ae&scoped=true"
import script from "./slideVideo.vue?vue&type=script&scoped=true&lang=js"
export * from "./slideVideo.vue?vue&type=script&scoped=true&lang=js"

import "./slideVideo.vue?vue&type=style&index=0&id=bf1816ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1816ae"]])

export default __exports__